<template>
  <div class="sticky-counter">
    <div class="sticky-counter__wrapper">
      <h1 class="sticky-counter__title">{{ content.title }}</h1>

      <div class="sticky-counter__content">
        <StickyCounterNumber
          :content="content.items"
          :currentActiveItem="currentActiveItem"
          :activatePercentsFromTop="activatePercentsFromTop"
        />

        <ul class="sticky-counter__list">
          <StickyCounterItem
            v-for="(item, index) in content.items"
            :key="item.title"
            :content="item"
            :index="index"
            :isActive="index === currentActiveItem"
            :activatePercentsFromTop="activatePercentsFromTop"
            @newActive="newActive"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

// mixins
// import SlideShow from "./../mixins/slide-show";

// components
import StickyCounterItem from "@/components/StickyCounterItem.vue";
import StickyCounterNumber from "@/components/StickyCounterNumber.vue";

export default {
  name: "StickyCounter",
  // mixins: [SlideShow],
  components: {
    StickyCounterItem,
    StickyCounterNumber
  },
  props: {
    content: Object
  },
  data() {
    return {
      currentActiveItem: 0,
      activatePercentsFromTop: 20
    };
  },
  computed: {
    ...mapState({
      currentScroll: state => state.globals.currentScroll
    }),
    showCurrentActiveItemNumber() {
      return `translateY(${this.currentActiveItem * -100}%)`;
    }
  },
  methods: {
    newActive(index) {
      this.currentActiveItem = index;
    }
  }
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.sticky-counter {
  @extend %page-margin-3-v;

  padding-top: 0;

  background-color: $color-white;
  color: $color-black;

  &__wrapper {
    @extend %page-max-width;
  }

  &__content {
    display: flex;
    align-items: flex-start;
  }

  &__title {
    @include typeface(expanded);
    @include typeset(display-3);

    @extend %page-margin-3;
    @extend %page-margin-3-v;

    @media screen and (min-width: 769px) {
      @include typeset(display-1);
      width: 60%;
    }
  }
}
</style>
